import styles from "./LoginPage.module.css"
import Navbar from "../../components/Navbar/NavbarOnboarding/Navbar";
import { Link } from "react-router-dom";
import LoginForm from "./components/LoginForm/LoginForm";
import { useTranslation } from "react-i18next";
import { useUserContext } from "../../context/UserContext";
import { useEffect } from "react";
import { useNavigate } from "react-router-dom";



/**
* Login page
* Contains login form.
* @returns TSX.Element
*/
const Login = () => {
    const { t } = useTranslation(); // Translation
    const { loggedIn } = useUserContext();
    const nav = useNavigate();

    // Redirect if user is already logged in
    useEffect(() => {
        if (loggedIn) {
            nav("/home")
        }
    },[loggedIn])
    
    return(
        <>
            <Navbar/>
            <div className={styles.Page}>
                <div className={styles.LoginBlock}>
                    <div className={styles.LoginTitle}>
                        {t("login.title")}
                    </div>
                    <div className={styles.LoginFormBlock}>
                        <LoginForm/>
                        <div className={styles.NoAccount}>
                            <div className={styles.NoAccountText}>
                                <p>{t("login.no_acc")}</p>
                            </div>
                            <div className={styles.NoAccountLink}>
                                <Link to="/login">{t("login.contact_us")}</Link>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
};

export default Login;
